import type * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1(P3):橙下划线 Tab(m02 形态为准,收编灰 pill SubTabBtn/tablist 等四种长相)。 */
export function Tabs<T extends string>({
	items,
	active,
	onChange,
	className,
}: {
	items: Array<{ key: T; label: React.ReactNode }>;
	active: T;
	onChange: (key: T) => void;
	className?: string;
}) {
	return (
		<div
			role="tablist"
			className={cn("flex flex-wrap gap-4 border-b border-surface-border", className)}
		>
			{items.map((it) => {
				const on = it.key === active;
				return (
					<button
						key={it.key}
						type="button"
						role="tab"
						aria-selected={on}
						onClick={() => onChange(it.key)}
						className={cn(
							"-mb-px border-b-2 pb-2 text-sm transition-colors duration-150",
							"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-state-focus rounded-t",
							on
								? "border-brand-accent font-semibold text-text-primary"
								: "border-transparent text-text-secondary hover:text-text-primary",
						)}
					>
						{it.label}
					</button>
				);
			})}
		</div>
	);
}
